export default __webpack_public_path__ + "a9b39f767509a6db31a150ed5f66d939.svg";